import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "listener",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    style: {"width":"100%"},
    class: "p-m-2"
  }, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, _mergeProps(_ctx.$attrs, {
              id: "name",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.vcomp.name.$invalid && _ctx.vcomp.name.$dirty
                            }],
              type: "text",
              modelValue: _ctx.alert.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.alert.name = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.valueChanged('name', $event.target.value))),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.vcomp.name.$touch()))
            }), null, 16, ["modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('kpi.alert.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.vcomp.name,
            additionalTranslateParams: { fieldName: _ctx.$t('kpi.alert.name') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_Dropdown, _mergeProps(_ctx.$attrs, {
              id: "listener",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.vcomp.alertListener.$invalid && _ctx.vcomp.alertListener.$dirty
                            }],
              modelValue: _ctx.alert.alertListener,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.alert.alertListener = $event)),
              options: _ctx.listeners,
              optionLabel: "name",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.valueChanged('alertListener', $event.value))),
              onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.vcomp.alertListener.$touch()))
            }), null, 16, ["modelValue", "options", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('kpi.alert.kpiListener')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.vcomp.alertListener,
            additionalTranslateParams: { fieldName: _ctx.$t('kpi.alert.kpiListener') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ])
      ])
    ]),
    _: 1
  }))
}